export default __webpack_public_path__ + "static/media/human-reproductive.85da4601.svg";